<div *ngIf="departmenUser" class="department-user-details">
    <div *ngIf="departmenUser.value.userId !== 0 || editMode">
        <form [formGroup]="departmentUserForm" *ngIf="editMode">
            <div class="add-user-row">
                <div class="picker-wrap">
                    <single-choice
                        formControlName="userId"
                        [completedUrl]="completionUrl"
                        [topic]="'users'"
                        [editMode]="editMode"
                        [icon]="'person'"
                        [ticketId]="100"
                        (choiceEvent)="relaySingleChoice($event)"
                        [labelOnDemand]="userIdLabelerByService"
                        [choiceObserver]="userIdObserver"
                    ></single-choice>
                </div>
                <action-button
                    *ngIf="showSaveButton"
                    class="btn-save"
                    (actionEvent)="saveDepartmentUser($event)"
                    icon="save"
                ></action-button>
            </div>
        </form>
    </div>
</div>
